"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uid = require("../utils/uid");

var _styles = require("../styles");

var _Sorter = _interopRequireDefault(require("./Sorter"));

var _CheckboxAll = _interopRequireDefault(require("./CheckboxAll"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Thead =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Thead, _PureComponent);

  function Thead() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = Thead.prototype;

  _proto.setColumns = function setColumns(columns, col, level) {
    if (!col.group) {
      columns.push(col);
      return 1;
    }

    if (level > this.columnLevel) this.columnLevel = level;
    var g = Array.isArray(col.group) ? col.group : [col.group];
    var last = columns[columns.length - 1];

    if (!g[level]) {
      columns.push(col);
      return 1;
    }

    var colSpan = 0;

    if (last && last.name === g[level]) {
      colSpan = this.setColumns(last.columns, col, level + 1);
      last.colSpan += colSpan;
      if (col.fixed) last.fixed = col.fixed;
      if (col.lastFixed) last.lastFixed = true;
    } else {
      var sub = [];
      colSpan = this.setColumns(sub, col, level + 1);
      columns.push({
        name: g[level],
        key: typeof g[level] === 'string' ? g[level] : (0, _uid.getUidStr)(),
        colSpan: colSpan,
        level: level,
        fixed: col.fixed,
        firstFixed: col.firstFixed,
        columns: sub
      });
    }

    return colSpan;
  };

  _proto.createTh = function createTh(trs, col, level) {
    var _this = this;

    var fixed = [];
    if (col.fixed) fixed.push("fixed-" + col.fixed);
    if (col.firstFixed) fixed.push('fixed-first');
    if (col.lastFixed) fixed.push('fixed-last');
    var _this$props = this.props,
        sorter = _this$props.sorter,
        onSortChange = _this$props.onSortChange,
        data = _this$props.data,
        datum = _this$props.datum,
        showSelectAll = _this$props.showSelectAll,
        disabled = _this$props.disabled;
    var align = col.align && "align-" + col.align;
    var ignoreBorderRight = this.rightBorderRecord[col.key] && 'ignore-right-border';

    if (col.title) {
      trs[level].push(_react.default.createElement("th", {
        className: (0, _classnames.default)(_styles.tableClass.apply(void 0, [level > 0 && 'condensed', align, ignoreBorderRight].concat(fixed)), col.className),
        rowSpan: this.columnLevel - level + 1,
        key: col.key
      }, typeof col.title === 'function' ? col.title(data) : col.title, col.sorter && _react.default.createElement(_Sorter.default, _extends({}, col, {
        current: sorter,
        onChange: onSortChange
      }))));
      return;
    }

    if (col.type === 'checkbox') {
      trs[level].push(_react.default.createElement("th", {
        key: "checkbox",
        rowSpan: trs.length,
        className: (0, _classnames.default)(_styles.tableClass.apply(void 0, ['checkbox'].concat(fixed)), col.className)
      }, showSelectAll && _react.default.createElement(_CheckboxAll.default, {
        disabled: disabled === true,
        data: data,
        datum: datum
      })));
      return;
    }

    var style = typeof col.name === 'string' ? undefined : {
      padding: 0
    };
    trs[level].push(_react.default.createElement("th", {
      className: (0, _classnames.default)(_styles.tableClass.apply(void 0, ['center', 'condensed', ignoreBorderRight].concat(fixed)), col.className),
      colSpan: col.colSpan,
      key: col.key,
      style: style
    }, col.name));

    if (col.columns) {
      col.columns.forEach(function (c) {
        return _this.createTh(trs, c, level + 1);
      });
    }
  };

  _proto.ignoreRightBorder = function ignoreRightBorder(column) {
    this.rightBorderRecord[column.key] = true;
    if (column.columns) this.ignoreRightBorder(column.columns[column.columns.length - 1]);
  };

  _proto.formatColumns = function formatColumns() {
    var _this2 = this;

    this.columnLevel = 0;
    var columns = [];
    this.props.columns.forEach(function (col) {
      _this2.setColumns(columns, col, 0);
    });
    this.rightBorderRecord = {};

    if (columns.length > 0 && this.props.bordered) {
      this.ignoreRightBorder(columns[columns.length - 1]);
    }

    return columns;
  };

  _proto.formatTrs = function formatTrs() {
    var _this3 = this;

    var columns = this.formatColumns();
    var trs = [];

    for (var i = 0; i <= this.columnLevel; i++) {
      trs.push([]);
    }

    columns.forEach(function (col) {
      return _this3.createTh(trs, col, 0);
    });
    return trs;
  };

  _proto.render = function render() {
    var trs = this.formatTrs();
    return _react.default.createElement("thead", null, trs.map(function (tr, i) {
      return _react.default.createElement("tr", {
        key: i
      }, tr);
    }));
  };

  return Thead;
}(_react.PureComponent);

Thead.propTypes = {
  columns: _propTypes.default.array.isRequired,
  data: _propTypes.default.array,
  datum: _propTypes.default.object,
  disabled: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.func]),
  onSortChange: _propTypes.default.func,
  sorter: _propTypes.default.object,
  showSelectAll: _propTypes.default.bool,
  bordered: _propTypes.default.bool
};
Thead.defaultProps = {
  showSelectAll: true
};
var _default = Thead;
exports.default = _default;